import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { Helmet } from 'react-helmet';
import { useState, useEffect } from 'react';
import server from './../static/json/server.json';

import CommentsContact from './CommentsContact';

import { useNavigate } from "react-router-dom";
import { renderToStaticMarkup } from 'react-dom/server';

import ReactGA from 'react-ga4';

const SERVER_ADDRESS = server["server"];

function checkIfFinished(id) {
	var score = localStorage.getItem('riddle-' + id + '-score');
    return (score != null);
}
function checkIfWon(id) {
	var score = localStorage.getItem('riddle-' + id + '-score');
	console.log(id);
	console.log(score);

    return (score > 0);
}
function checkIfStarted(id) {
	var guesses = localStorage.getItem('guesses-' + id);
    return (guesses != null);
}

function checkIcon(id) {
	const icon = localStorage.getItem('riddle-' + id + '-icon');
	if(icon) {return icon;}
	//else {return "🕵"; }
	else {return  (<img className="hiddenAnswer" src="/icon.png" />); }
}

function checkAnswer(id) {
	return localStorage.getItem('riddle-' + id + '-result');
}

function checkHint(id) {
	return localStorage.getItem('riddle-' + id + '-hint');
}

function checkGuesses(id) {
	const savedHints = localStorage.getItem('guesses-' + id);
	const hintsParsed = savedHints ? JSON.parse(savedHints) : [];
	const guesses = hintsParsed.length;
	if(guesses == 0) {
		return "";
	} else if(guesses == 1) {
		return "1 guess";
	} else {
		return guesses + " guesses";
	}

}

function goToUrl(url) {
	window.location.href = url;
}

function formatDate(dateString) {
	const date = new Date(dateString);
	const formattedDate = date.toISOString().split('T')[0];
	return formattedDate;
}

function Statistics({lang}) {

	const { t } = useTranslation();
	const [riddles, setRiddles] = useState([]);
	const [url, setUrl] = useState(null);
    const [noRiddles, setNoRiddles] = useState(false);
    const [finished, setFinished] = useState(null);

	useEffect(() => {
    	const fetchUrl = async () => {
        	try {
        		const response = await fetch(SERVER_ADDRESS + "/riddles", {
        	        method: "GET",
        	        headers: { 'Content-Type': 'application/json' }
        	    });
        	    var riddlesArray = await response.json();

				const today = new Date();
                riddlesArray = riddlesArray.filter(doc => new Date(doc.date) <= today);

				console.log(riddlesArray[0].date);
				console.log(riddlesArray[1].date);
				riddlesArray.sort((a, b) => new Date(b.date) - new Date(a.date));


				var riddlesCopy = [...riddlesArray];


				setRiddles(riddlesCopy);

				//Find new riddle
				const shuffle = arr => arr.sort(() => Math.random() - 0.5);
                shuffle(riddlesArray);
				var newRiddle = "";
        		riddlesArray.forEach((riddle) => {
		            if(!newRiddle && !checkIfStarted(riddle["id"])) {
		                newRiddle = riddle["id"];
		            }
		        });

		        if(!newRiddle) {
		            riddlesArray.forEach((riddle) => {
			            if(!newRiddle && !checkIfFinished(riddle["id"])) {
			                newRiddle = riddle["id"];
			            }
			        });
		        }

		        if(!newRiddle) {
		            setNoRiddles(true);
		            setUrl("/" + lang + "/riddles");
		        } else {
		            setUrl("/" + lang + "/guess?id=" + newRiddle);
		        }

		        const finishedRiddles = (riddlesArray.filter((riddle) => checkIfFinished(riddle["id"]))).length;
		        console.log(finishedRiddles);
		        setFinished(finishedRiddles);


        	} catch (error) {
				console.log("error");
				console.log(error);
            }
        }
		fetchUrl();
    }, [lang]);



    function goToNextRiddle() {
        ReactGA.event({
			category: 'Guesser',
		    action: 'StartRiddle',
            label: 'Statistics'
		});
		window.location.href = url;
    }

	const tilesetHtml =  (
        <div className="mainPart">
        <Helmet>
            <title>What am I? - Riddles</title>
            <meta name="description" content="Riddles" />
            <link rel="canonical" href="https://www.guessie.com/en/riddles" />
        </Helmet>
        <Container>
            <h2>All riddles </h2>

            <center>

                {
                    noRiddles
                    ? <h5> You’ve solved all the puzzles. Come back tomorrow to solve more.  </h5>
	                : <>
	                    <h5>You finished {finished} out of {riddles.length} riddles. Keep playing!</h5>
	                    <Button variant="success" className="default-btn" onClick={() => goToNextRiddle()} >
	                        {t('playRandom')}
	                    </Button>

	                </>

                }

            </center>

			<br/>
			{
				riddles.length > 0
				? <>
					<h5>Here's a list of all available riddles. You can choose the one you want to solve now. </h5>
					<div className="fakeTable">
						<Row className=" greyRow">
							<Row className="tableRow "  >
								<div className="guessIcon"> <span> {checkIcon('x')} </span> </div>
								<div className="guessText smallPart">
									<span class="bigText">  New level tomorrow  </span><br/>
									2025-04-30
								</div>

								<div className="guessText smallPart rightText">  </div>

							</Row>



						</Row>


					{
						riddles.map(riddle => (

							<Row className="rowWithButton" onClick={() => goToUrl("/en/guess?id=" + riddle["id"] )}>
								<Row className="tableRow"  >
									<div className="guessIcon"> <span> {checkIcon(riddle["id"])} </span> </div>
									<div className="guessText smallPart">

										 {
										    checkIfFinished(riddle["id"])
										    ? <><span class="bigText">  {checkAnswer(riddle["id"])}  </span><br/></>
										    : <></>
										 }

										 {
										    checkIfStarted(riddle["id"])
										    ? <>{checkHint(riddle["id"])} <br/></>
										    : <></>
										 }

										 { formatDate(riddle["date"]) }
									</div>

									<div className="guessText smallPart rightText"> {checkGuesses(riddle["id"])}  </div>

								</Row>

								{
									checkIfFinished(riddle["id"])
									? <Button className="buttonInTable small-btn purple-btn">Check</Button>
									: checkIfStarted(riddle["id"])
										? <Button className="buttonInTable small-btn">Continue</Button>
										: <Button className="buttonInTable small-btn">Play</Button>

								}

							</Row>

						))
					}
					</div>
					</>
				: <></>
			}
			<br/>




        </Container>
        </div>
      );

    return tilesetHtml
}

export default Statistics;

